import { SubStateItem } from './sub-state-item';
import { OrderDataItem } from './order-data-item';
import { Scenario } from './scenario';
import { OrderState } from './order-state';
import { OrderStateItem } from './order-state-item';
import { OrderStateList } from './order-state-list';

export class OrderData {
  id = '';
  text = '';
  orderIndex = 0;
  completionDate = '';
  endTime = '';
  orderGroup = '';
  orderState: OrderStateItem = OrderStateList.undefinedItem;
  activeUserName = '';
  lastEditUserName = '';
  userSince = '';
  assetName = '';
  assetPath = '';
  virtualLiveFormName = '';
  orderSubState: SubStateItem | undefined = undefined;
  scenario: Scenario | undefined = undefined;
  additionalData: OrderDataItem[] = [];
  isEditAllowed = false;
  hasReport = false;

  public canEdit(): boolean {
    return this.isEditAllowed;
  }

  public canFinish(): boolean {
    return this.isEditAllowed;
  }

  public canCancel(): boolean {
    return false;
  }

  public canCheckOut(): boolean {
    if (this.orderState == undefined) {
      return false;
    }

    if (this.orderState.state != OrderState.Paused && this.orderState.state != OrderState.Released) {
      return false;
    }

    return this.isEditAllowed;
  }

  checkOrderState(state: OrderState, allowedStates: OrderState[]): boolean {
    if (this.orderState == undefined) {
      return false;
    }
    return allowedStates.includes(state);
  }
}
